module.exports = {
  breadcrumb_navigation: 'Breadcrumb navigation',
  skip_to_content: 'Skip to main content',
  search: 'Search',
  modal: 'Dialog',
  go_to_previous_slide: 'Go to previous slide',
  go_to_next_slide: 'Go to next slide',
  toggle_contents_list: 'Toggle contents list',
  sidenav: {
    label: 'Main navigation',
  },
  back: 'Back',
  configure_notifications: 'Configure notifications',
  show_all: 'Show all',
  courses: 'Courses',
  correct: 'Correct',
  date_until: 'Until %{date}',
  days_left: '1 day left|%{days} days left',
  ending_today: 'Ending today',
  forename: 'Forename',
  lastname: 'Lastname',
  loading: 'Loading',
  updating: 'Updating...',
  retry: 'Retry',
  mail: 'Email',
  member: 'Member | Members',
  multiple_choice: 'Multiple Choice',
  notifications_confirm: 'Please confirm the notification request',
  optional: 'optional',
  password: 'Password',
  current_password: 'Current password',
  current_password_placeholder: 'Your current password',
  confirm_password: 'Enter your password to confirm your change',
  player: 'Player | Players',
  quiz_battle: 'Quiz Battle',
  self: 'Me',
  settings_saved: 'The settings have been saved successfully.',
  sort: 'Sort',
  started_at_date: 'Started on %{date}',
  starts_at_date: 'Starts on %{date}',
  to_home: 'To Home',
  username: 'Username',
  realname: 'Full name',
  want_notifications: "Do you want to be notified when it's your turn?",
  wrong: 'Wrong',
  user_search_placeholder: 'Name or Email...',
  user_search_placeholder_wo_email: 'Name...',
  powerlearning: 'Powerlearning',
  tests: 'Tests',
  not_found_404: 'This page could not be found',
  notifications_title: 'Configure notifications',
  notification_successful_body: 'You will receive a notification when it is your turn',
  notification_successful_title: 'Notifications enabled',
  offline: 'Offline',
  online: 'Online',
  offline_message: 'This function is available as soon as you are online again.',
  close: 'Close',
  voucher_code: 'Voucher code',
  app_by_keeunit: 'Powered by <a href="https://www.keelearning.de" target="_blank">keeunit GmbH</a>',
  see_whats_new: "See what's new.",
  what_do_you_want_to_learn_today: 'What do you want to learn today?',
  last_learned: 'Last learned',
  missing_module_title: "Unfortunately, you don't have access to this content.",
  missing_module_description: 'Please contact your administrator for access.',
  access_denied: 'Access denied',
  question_preview: 'Question preview',
  question_preview_unavailable: 'Unfortunately, this question cannot be displayed.',
  enter_query_to_start_search: 'Enter a search term to start the search.',
  no_search_results: 'No results for your search',
  no_results_for_filters: 'No entries for the selected filters',
  results: 'Result | Results',
  reset_search_filters: 'Clear all filters',
  back_to_overview: 'Back to overview',
  filter: 'Filter:',
  filter_title: 'Filter',
  file_type: 'File type',
  set_filters: 'Apply filter',
  new_content: 'New content',
  new: 'New',
  no_audio_support: 'Your browser does not support the audio element.',
  download: 'Download',
  filter_all: 'All',
  filter_unseen: 'Not yet viewed',
  filter_seen: 'Already viewed',
  want_more: 'Want more?',
  want_more_explanation: 'Help to build up the knowledge base in your company and expand the quiz and powerlearning.',
  total_progress: 'Overall progress',
  back_to_home: 'Return to home page',
  save: 'Save',
  abort: 'Cancel',
  dofilter: 'Filters:',
  available: 'Availability',
  not_available_anymore: 'No longer available',
  webinars: 'Webinars',
  minutes: '1 minute | %{n} minutes',
  from: 'From',
  you_are_offline: 'You are offline. Some features are only available when you are online.',
  learningmaterials: 'Media library',
  show_more: 'Show more',
  show_less: 'Show less',
  show_more_text_label: 'Show more text',
  open_link: 'Open link',
  please_choose: 'Please select',
  suggest_question: {
    suggest_new_question: 'Suggest new question',
    question_label: 'Question',
    category_label: 'Category',
    cant_load_suggestion_categories: 'Unfortunately, not all the required data could be loaded. Please try again later.',
    answers_explanation: 'Please enter one correct and three incorrect answers for your question.',
    correct_answer_label: 'Correct answer',
    wrong_answer_x_label: 'Incorrect answer %{x}',
    submit_question: 'Submit question',
    couldnt_suggest_question: 'Unfortunately, the question could not be submitted',
    question_suggested_successfully: 'Thank you very much! We will check your question shortly.',
  },
  ad: 'Ad',
  submit: 'Submit',
  page_x: 'page %{page}',
  page_x_of_y: 'page %{currentPage} of %{totalPages}',
  delete: 'Delete',
  edit: 'Edit',
  reply: 'Reply',
  hi_name: 'Hi %{name}.',
  or: 'or',
  x_days_left: '1 day left | %{days} days left',
  required: 'required',
  x_days_from_start: '%{x} day from start | %{x} days from start',
  x_weeks_from_start: '%{x} week from start | %{x} weeks from start',
  x_months_from_start: '%{x} month from start | %{x} months from start',
  userAvatar: 'User avatar',
  play: 'Play',
  pause: 'Pause',
  click_again_to_stop_recording: 'Click again to stop recording',
  next: 'Next',
  previous: 'Previous',
  typingIndicator: {
    usersTyping: '{count} user is typing | {count} users are typing',
  },
}
